import React from 'react';
import Private from '../../containers/private-route';
import Page from './component';

const Routes = [
    <Private exact
        key="diseases-route"
        path="/diseases"
        component={Page} />
];

export default Routes;